// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__Yc9Wq","header":"PatientBlock_header__3J0dY","label":"PatientBlock_label__2MAxy","option":"PatientBlock_option__qOnfk"};